// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"717":"37876018","771":"c2638faf"}[chunkId] + ".chunk.js";
};